<template>
  <!-- 暂时关闭 -->
  <div class="taboo add-drug-taboo">
    <div class="title">
      <Tooltip
        content="处方中可能与患者的辨证产生禁忌的用药，在此处提醒说明，需点击确认使用，方可提交处方。"
        placement="right-end"
      >
        <span>
          用药禁忌
          <Icon type="ios-information-circle-outline" />
        </span>
      </Tooltip>
    </div>
    <div class="taboo-body">
      <div
        v-for="(item, index) in drugListByDialectic"
        :key="index"
        class="taboo-item"
      >
        {{ index + 1 }}、{{ item.dialecticName }}：{{
          item.drugList.length ? item.drugList.join("、") : "暂无内容"
        }}
      </div>
      <empty v-if="drugListByDialectic.length == 0" text="暂无内容" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    drugList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    info(newValue, oldValue) {
      this.getDialecticInfoByKey();
    },
  },
  computed: {
    ...mapGetters(["dicts"]),
    Dialectic_Taboo_Drug() {
      let list = this.dicts.Dialectic_Taboo_Drug || [];
      let tabooDrugList = [];
      let arr = this.dialecticNames.map((i) => {
        let item = list.find((j) => j.string1 == i);
        let drugList = item ? item.string2.split(",") : [];
        tabooDrugList.push(...drugList);
        return {
          dialecticName: i,
          drugList,
        };
      });
      this.$emit("tabooDrugList", tabooDrugList);
      return arr;
    },
    drugListByDialectic() {
      return this.Dialectic_Taboo_Drug;
    },
  },
  data() {
    return {
      dialecticInfo: [],
      dialecticNames: [],
    };
  },
  methods: {
    getDialecticInfoByKey() {
      this.api2("getDialecticInfoByKey", {
        symptomNo: this.info.symptomNo,
      }).then((res) => {
        this.dialecticInfo = JSON.parse(res.result.dialecticInfo);
        this.dialecticNames = this.dialecticInfo.map((i) => i.dialecticName);
      });
    },
    init() {
      this.$store.dispatch("getWideUseList", {
        key: "Dialectic_Taboo_Drug",
        type: "saas",
      });
      this.getDialecticInfoByKey();
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.add-drug-taboo {
  margin-bottom: 10px;
  border: 1px solid #eee;
  padding: 10px;
  border-radius: 5px;

  .title {
    padding-bottom: 5px;
  }

  .taboo-body {
    font-weight: bold;
    line-height: 26px;
    // height: 50px;
    // overflow: hidden;
    &-more {
      height: auto;
    }
  }
}
</style>